import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { CircularProgress, styled } from '@mui/material';
import { RouteComponentProps } from '@reach/router';
import { graphql } from '../../../gql';
import { useAuth } from '@calefy-inc/authentication';
import { ErrorP } from '../../common/Typography';

interface AdminPanelStatsProps extends RouteComponentProps {}
export const AdminPanelStats = (_props: AdminPanelStatsProps) => {
  const [totalQuotes, setTotalQuotes] = useState<number | null | undefined>();
  const [totalForms, setTotalForms] = useState<number | null | undefined>();
  const [totalQuestions, setTotalQuestions] = useState<
    number | null | undefined
  >();
  const { token } = useAuth();
  const [getAdminPanelStats, { loading, error, data }] =
    useLazyQuery(ADMIN_PANEL_STATS);

  // load the data once we have it
  useEffect(() => {
    if (data?.adminPanelStats) {
      setTotalQuotes(data.adminPanelStats?.totalQuotes);
      setTotalForms(data.adminPanelStats?.totalForms);
      setTotalQuestions(data.adminPanelStats?.totalQuestions);
    }
  }, [data]);

  // get the data
  useEffect(() => {
    if (token) {
      getAdminPanelStats({ variables: { token } });
    }
  }, [token]);

  return (
    <StatsPanelContainer>
      <Typography variant='h1'>Statistics</Typography>
      {error ? <ErrorP>error.message</ErrorP> : null}
      <StatsContainer>
        {[
          ['Total Quotes', totalQuotes],
          ['Total Forms', totalForms],
          ['Total Questions', totalQuestions],
        ].map(([heading, value]) => {
          return (
            <StatsCard>
              <StatsCardHeader>{heading}</StatsCardHeader>
              <StatsCardValue>
                {loading ? <CircularProgress /> : value || '-'}
              </StatsCardValue>
            </StatsCard>
          );
        })}
      </StatsContainer>
    </StatsPanelContainer>
  );
};

const StatsPanelContainer = styled('div')({});
const StatsContainer = styled('div')(({ theme }) => {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(1),
  };
});
const StatsCard = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});
const StatsCardHeader = styled(Typography)({});
const StatsCardValue = styled(Typography)({});

const ADMIN_PANEL_STATS = graphql(`
  query adminPanelStats($token: String!) {
    adminPanelStats(token: $token) {
      totalQuotes
      totalForms
      totalQuestions
    }
  }
`);
